import * as React from 'react'
import './Replay.css'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import Alert from 'react-s-alert'
import NewClassesList from "./classes/NewClassesList";
import ClassDetails from "./classes/ClassDetails";
import * as firebase from "firebase";
import {TableRecord} from "../common/table/EnhancedTable";
import {CircularProgress} from "@material-ui/core";

interface ReplayState {
    currentClassId: string | null;
    isLoading: boolean;
    classes: TableRecord[];
}

class Replay extends React.Component<any, ReplayState>{

    constructor(props: any) {
        super(props);
        this.state = {
            currentClassId: null,
            isLoading: false,
            classes: []
        };
    }

    public componentDidMount(): void {
        this.fetchClasses();
    }

    public render() {
        return <div className="Replay">
            <Alert stack={true}/>
            {
                this.state.isLoading && <CircularProgress size={100} />
            }
            {
                !this.state.isLoading &&
                <NewClassesList
                    onSelect={this.onSelect}
                    classes={this.state.classes}
                />
            }
            {
                this.state.currentClassId &&
                <ClassDetails
                    currentClassId={this.state.currentClassId}
                    onClassSaved={this.onClassSaved}
                />
            }
        </div>
    }

    private fetchClasses = () => {
        this.setState({isLoading: true});
        firebase.firestore().collection('classes')
            .orderBy("date", "desc").get()
            .then(o => {
                return o.docs.map( doc => this.createClassTableRecord(doc.id, doc.data()));
            })
            .then( (classes: TableRecord[]) => {
                this.setState({classes, isLoading: false});
            });
    };

    private createClassTableRecord = (id: string, data: any): any => {
        const t = data.date.seconds * 1000;
        return {
            id,
            date: new Date(t).toLocaleString("en-US"),
            timestamp: t,
            playbackURL: this.forceHTTPS(data.playbackURL),
            thumbURL: this.forceHTTPS(data.thumbURL),
            teacherId: data.teacherId,
            availableForReplay: data.availableForReplay
        }
    };

    private onSelect = (selected: string[]) => {
        this.setState({currentClassId: selected.length > 0 ? selected[0] : null});
    };

    private onClassSaved = (classId: string) => {
        this.updateClassInPlace(classId);
    };

    /**
     * This methods updates a single class entry from the list of currently fetched classes
     * in the state.
     */
    private updateClassInPlace = (classId: string) => {
        const index = this.state.classes.findIndex(aClass => aClass.id === classId);
        firebase.firestore().collection('classes')
            .doc(classId).get()
            .then(o => {
                const newRecord = this.createClassTableRecord(o.id, o.data());
                this.setState(currentState => {
                    currentState.classes[index] = newRecord;
                    return {
                        classes: currentState.classes
                    }
                });
            });
    };

    private forceHTTPS(url: string): string {
        if (url !== undefined && location.protocol === 'https:' && url.indexOf('https') < 0) {
            return url.replace('http', 'https')
        }
        return url
    }


}

export default Replay


// WEBPACK FOOTER //
// ./src/components/replay/Replay.tsx